


<template>
  <v-layout>
    <v-flex d-flex xs8 style=" background-color:black">
      <VueCodeHighlight>
        <pre class="language-javascript">
          <code>

URL https://api.smart.press/p/

// EXAMPLE TX

// SEND ASSET

POST 'https://api.smart.press/p/send'
body: {
  data: {
    sender: STRING, // this user has to already exist in our system *See createAccount(tx) below
    receiver: STRING, // if this user isnt recognised we will make it for you
    assetType: 'token', 
    symbol: 'AAA', // Deafult asset symbol
    amount: INTEGER, // How many of the asset would you like to send?
    project_owner_id: STRING, // Can be found in your smartpressConfig file (config.user_id),
    memo: STRING, (max 256 characters) // Optional text area for information to be stored with the transaction
  },
  sp_key: {
    api_key: STRING // Can be found in your smartpressConfig file (config.API_KEY),
  }
}








// CREATE ACCOUNT

POST 'https://api.smart.press/p/createAccount'
body: {
  data: {
    project_owner_id: STRING // Can be found in your smartpressConfig file (config.user_id),
    user_id: STRING // the user_id you would like for the new user - TIP: for a large userbase use hash and salted versions of your main applications user_id's
  },
  sp_key: {
    api_key: STRING // Can be found in your smartpressConfig file (config.API_KEY),
  }
}












// GET BALANCE

POST 'https://api.smart.press/p/getBalance'
body: {
  data: {
    symbol: 'AAA', // Deafult asset symbol
    project_owner_id: STRING, // Can be found in your smartpressConfig file (config.user_id)
    user_id: STRING, // the user_id you would like the balance of
    contract_balance: BOOLEAN, // Optional: if you would like the main contracts balance, flag this as true. note you wont need to provide a user_id if true
  },
  sp_key: {
    api_key: STRING // Can be found in your smartpressConfig file (config.API_KEY),
  }
}




          </code>
        </pre>
      </VueCodeHighlight>
    </v-flex>
    <v-flex d-flex xs4 style=" background-color:black">
             
        <pre style="color:white;font-size:16px;margin:36px 20px;" >
         








// Response
{ 
  success: true, 
  data: { 
    contract: "sptoken22325", 
    transaction_id: "c3f5...f633", 
    action_type: "transfer", 
    time: 1573539270302, 
    data: "hi", 
    primary_actor: "emerald12242", 
    secondary_actor: "emerald12235", 
    no_units: 1, 
    symbol: "AAA", 
    block_explorer: "https://telos.eosx.io/tx/c3f5...f633" 
  } 
}




// Response
{ 
  success: true, 
  account_name: "emerald83624", 
  user_id: "user-abc-123" 
}






// Response
{ 
  user_id: "user-abc-123",
  symbol: "AAA",
  contract: "sptoken22325",
  contract_balance: false,
  account_name: "emerald12241",
  balance: "32.0000 AAA",
  no_units: "32.0000" 
}



       
        </pre>
    
    </v-flex>
  </v-layout>
</template>

<script>
  import store from "@/store"

  import { component as VueCodeHighlight } from 'vue-code-highlight';

  export default {
    data () {
      return {
 
        abc: '123',
        items: [
          { x: 100, text: 'Getting started' },
          { x: 300, text: 'Create' },
          { x: 500, text: 'Issue' },
          { x: 800, text: 'Transfer' },
          { divider: true },
        ]
      }
    },
    components: {
      VueCodeHighlight
    },
    props: {
      keys: String,
      account: String
    },
    watch:  {
 
    
    },
    methods: {
      goto(x) {
        this.$vuetify.goTo(x)
      }
    },
    destroyed: function () {
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
